import { Ref, ref } from 'vue'

export function useArrowKeyVerticalListNavigation(itemCount: Ref<number>) {
  const currentFocusIndex = ref<number | null>(null)

  const focusNextItem = (currentIndex: number): void => {
    const nextIndex = (currentIndex + 1) % itemCount.value
    currentFocusIndex.value = nextIndex
  }

  const focusPreviousItem = (currentIndex: number): void => {
    const previousIndex = (currentIndex - 1 + itemCount.value) % itemCount.value
    currentFocusIndex.value = previousIndex
  }

  const onItemFocus = (index: number): void => {
    currentFocusIndex.value = index
  }

  const onItemBlur = (index: number): void => {
    if (currentFocusIndex.value === index) {
      currentFocusIndex.value = null
    }
  }

  const onKeyDown = (event: KeyboardEvent): void => {
    if (currentFocusIndex.value === null) return
    switch (event.key) {
      case 'ArrowDown':
        focusNextItem(currentFocusIndex.value)
        break
      case 'ArrowUp':
        focusPreviousItem(currentFocusIndex.value)
        break
      default:
        return
    }
  }

  return {
    currentFocusIndex,
    focusNextItem,
    focusPreviousItem,
    onItemFocus,
    onItemBlur,
    onKeyDown
  }
}
